import React from 'react';

import { useTranslation } from '../../../../../../hooks';

interface FreeDropClaimErrorPopupProps {
  message: string;
  onClose: () => void;
}

export const FreeDropClaimErrorPopup: React.FC<FreeDropClaimErrorPopupProps> = ({
  message,
  onClose
}) => {

  const t = useTranslation();

  return (
    <div className="prize-claim-error-popup">
      <p className="prize-claim-error-message">{ t(message) }</p>
      <div className="free-drop-popup-close-block" onClick={onClose}>
        <i className="icon-close free-drop-popup-close" />
      </div>
    </div>
  );
};
